<template>
  <Teleport
    to="#modal"
  >
    <transition :name="transitionName">
      <div
        v-if="value"
        :class="[$attrs.class, overlayClass]"
        @click.self="clickOverlay"
      >
        <div
          :id="idName"
          key="modal-window"
          :class="modalClass"
          :style="customStyle"
        >
          <div class="modal-inner">
            <slot />
          </div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script>

export default {
  name: 'ModalWindow',

  components: {},

  props: {
    customStyle: {
      type: [String, Object],
      default () {
        return {}
      },
    },
    value: {
      type: Boolean,
      required: false,
      default: false,
    },
    idName: {
      type: String,
      default: null,
    },
    className: {
      type: String,
      default: null,
    },
    overlay: {
      type: Boolean,
      default: true,
    },
    noClose: {
      type: Boolean,
      default: false,
    },
    modalNameForHtml: {
      type: String,
      default: '',
    },
    transitionName: {
      type: String,
      default: 'modal',
    },
    overlayClasses: {
      type: String,
      default: '',
    },
  },

  emits: [
    'input',
    'modalClose',
    'modalOpen',
    'update:value',
  ],

  computed: {
    overlayClass: ({ overlay, overlayClasses }) => [overlayClasses, 'modal-overlay', overlay ? 'active' : ''],
    modalClass: ({ className }) => ['modal-window'].concat(className),
  },

  watch: {
    value: {
      handler (val) {
        if (val) {
          this.$emit('modalOpen', this.modalNameForHtml)
        } else {
          this.$emit('modalClose')
        }
      },
      immediate: true,
    },
  },

  mounted () {
    document.addEventListener('keyup', this.handleClose)
  },

  beforeUnmount () {
    document.removeEventListener('keyup', this.handleClose)
    this.$emit('modalClose')
  },

  methods: {
    prevent (event) {
      event.preventDefault()
      event.stopPropagation()
    },
    closeModal () {
      if (!this.value) return
      this.sendGTMMarkupEvent({ block: 'ModalWindow', element: 'Block', action: 'Close', details: '' })
      this.$emit('input', false)
      this.$emit('update:value', false)
    },

    clickOverlay () {
      if (!this.noClose) {
        this.closeModal()
      }
    },

    handleClose (evt) {
      if (evt.keyCode === 27) this.closeModal()
    },
  },
}
</script>

<style lang="scss">
.modal-root {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1900;

  &:empty {
    display: none;
  }
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;
  overflow: auto;

  cursor: pointer;

  &.active {
    background-color: rgba(map-get($colors, 'black_0'), .4);
  }
}

.b-menu-customization__alert--confirm {
  .modal-inner {
    display: flex;
    flex-flow: column;
    justify-content: center;
  }
}
.modal-window {
  position: relative;

  max-width: 100%;
  max-height: 100%;

  background-color: map-get($colors, 'white');
  box-shadow: 0 2px 4px 0 rgba(map-get($colors, 'black_0'), 0.2);
  border-radius: 16px;
  cursor: initial;
  transition: all .3s ease-in-out;
  &__close-inside {
    .close-icon {
      right: 0.3em !important;
      top: 0.3em !important;
      z-index: 2;

      padding: 0 !important;

      background-color: transparent !important;
      color: map-get($colors, 'black_0') !important;

      svg {
        width: 0.14em !important;
        height: 0.14em !important;
        stroke: map-get($colors, 'black_0');
      }
    }
  }

  &.alert-window {
    padding: 1rem .8rem .6rem;
    text-align: center;

    .actions {
      display: flex;
      justify-content: space-evenly;
    }
    .button {
      padding: .1rem;
      margin: 0.15rem 0.1rem;
    }
  }

  .close-icon {
    right: -.4rem;
    top: 0;
    color: map-get($colors, 'white');
    opacity: .8;
    padding: .1em;
    position: absolute;
    background: map-get($colors, 'black_0');
    border-radius: 50%;

    svg {
      width: .1em;
      height: .1em;
    }
  }

  &.b-menu-custom__modal{
    width: 11.3rem;
    overflow-y: auto;
  }
}

.modal-enter-active,
.modal-leave-active {
  transition: all .3s ease-in-out;
}
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
  transform: scale(1.1);
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease-in-out;
}
.slide-up-enter,
.slide-up-leave-active {
  opacity: 0;
  transform: translate(-20px);
}

@keyframes blowUpModal {
  0% {
    transform:scale(0);
  }
  100% {
    transform:scale(1);
  }
}
</style>
